import { createPlayIcon } from './icons';

export interface PauseOverlayHandlers {
  onResume: () => void;
  onRestart: () => void;
  onMenu: () => void;
}

export interface PauseOverlay {
  mount(parent: HTMLElement): void;
  unmount(): void;
}

export function createPauseOverlay(handlers: PauseOverlayHandlers): PauseOverlay {
  let overlay: HTMLDivElement | null = null;

  function build(): HTMLDivElement {
    const root = document.createElement('div');
    root.className = 'pause-overlay overlay';
    root.dataset.testid = 'pause-overlay';

    const panel = document.createElement('div');
    panel.className = 'pause-panel modal';

    const ribbon = document.createElement('div');
    ribbon.className = 'pause-ribbon headline';
    ribbon.textContent = 'BREAK TIME!';
    panel.appendChild(ribbon);

    const title = document.createElement('h1');
    title.className = 'pause-title headline';
    title.textContent = 'Paused';
    panel.appendChild(title);

    const subtitle = document.createElement('p');
    subtitle.className = 'pause-subtitle';
    subtitle.textContent = 'Take a breath, then jump back in!';
    panel.appendChild(subtitle);

    const buttons = document.createElement('div');
    buttons.className = 'pause-buttons';

    const resumeBtn = document.createElement('button');
    resumeBtn.type = 'button';
    resumeBtn.className = 'chunky-btn teal';
    resumeBtn.dataset.testid = 'resume-btn';
    resumeBtn.appendChild(createPlayIcon(2));
    const resumeLabel = document.createElement('span');
    resumeLabel.textContent = 'KEEP PLAYING';
    resumeBtn.appendChild(resumeLabel);
    resumeBtn.addEventListener('click', handlers.onResume);

    const restartBtn = document.createElement('button');
    restartBtn.type = 'button';
    restartBtn.className = 'chunky-btn yellow small';
    restartBtn.dataset.testid = 'restart-btn';
    restartBtn.textContent = '↻ Start Over';
    restartBtn.addEventListener('click', handlers.onRestart);

    const menuBtn = document.createElement('button');
    menuBtn.type = 'button';
    menuBtn.className = 'chunky-btn neutral small';
    menuBtn.dataset.testid = 'menu-btn';
    menuBtn.textContent = '⌂ Main Menu';
    menuBtn.addEventListener('click', handlers.onMenu);

    buttons.append(resumeBtn, restartBtn, menuBtn);
    panel.appendChild(buttons);
    root.appendChild(panel);
    return root;
  }

  function mount(parent: HTMLElement): void {
    if (overlay) return;
    overlay = build();
    parent.appendChild(overlay);
  }

  function unmount(): void {
    overlay?.remove();
    overlay = null;
  }

  return { mount, unmount };
}
